import { render } from "./PageTips.vue?vue&type=template&id=2fb255c6"
import script from "./PageTips.vue?vue&type=script&lang=js"
export * from "./PageTips.vue?vue&type=script&lang=js"

import "./PageTips.vue?vue&type=style&index=0&id=2fb255c6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__